<script>
import { Tabs } from "element-ui";
export default {
  name: "aia-tabs",
  extends: Tabs
};
</script>
<style>
.el-tabs__active-bar .is-top {
  width: 84px !important;
  transform: translateX(288px);
}
</style>